import {NPEntry, NPPreloader} from './components';
import {NDCountryDependent} from './directives';
import { createMetaManager } from 'vue-meta'
import locale from './mixins/locale';
import helper from './mixins/app';
import Notifications from '@kyvg/vue3-notification';
import regeneratorRuntime from 'regenerator-runtime';
import tooltipDirective from "./tooltip-directive";
/**
 *
 * @param Vue Vue instance
 * @param args
 * @constructor
 *
 * Install all elements to the Vue instance
 *
 *  Usage:
 *  import Netpify from 'path/to/netpify';
 *  import Vue from 'vue';
 *  Vue.use(Netpify);
 */
const Netpify = {
    install(app, options) {
        // Register Components
        app.component('np-preloader', NPPreloader);
        app.component('np-entry', NPEntry);

        // Register directives
        app.directive('country-dependent', NDCountryDependent);
        app.use(createMetaManager())
        // app.use(VueMeta,  {
        //     refreshOnceOnNavigation: true
        // })

        // Use Notifications
        app.use(Notifications);

        app.use(regeneratorRuntime);
        app.directive('tooltip', tooltipDirective);
        // Register mixins
        app.mixin(locale);
        app.mixin(helper);
    }
}

export default Netpify;